import { createModal } from './modal.js';

const FIELDS = ['cf_name', 'cf_email', 'cf_subject', 'cf_message'];
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// Keep the loading state on screen at least this long so a fast response reads
// as a deliberate "sending" beat instead of a flicker.
const MIN_BUSY_MS = 500;

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function setFieldError(form, id, message) {
  const input = form.querySelector(`#${id}`);
  const feedback = form.querySelector(`#${id}-feedback`);
  if (!input || !feedback) return;
  input.closest('[data-field]').classList.toggle('form-group--error', Boolean(message));
  feedback.textContent = message || '';
}

function clearErrors(form) {
  FIELDS.forEach((id) => setFieldError(form, id, ''));
}

function validate(form, messages) {
  const errors = {};
  const value = (id) => (form.querySelector(`#${id}`)?.value || '').trim();

  FIELDS.forEach((id) => {
    if (!value(id)) errors[id] = messages[id];
  });
  if (!errors.cf_email && !EMAIL_RE.test(value('cf_email'))) errors.cf_email = messages.cf_email_bad;

  return errors;
}

function applyErrors(form, errors) {
  Object.entries(errors).forEach(([id, message]) => setFieldError(form, id, message));
  const first = FIELDS.find((id) => errors[id]);
  if (first) form.querySelector(`#${first}`)?.focus();
}

export function initContactForm() {
  const form = document.querySelector('[data-contact-form]');
  const config = window.alxContato;
  if (!form || !config) return;

  const modalRoot = document.getElementById('contact-feedback');
  const modal = modalRoot ? createModal(modalRoot) : null;
  const modalTitle = modalRoot?.querySelector('[data-modal-title]');
  const modalText = modalRoot?.querySelector('[data-modal-text]');
  const button = form.querySelector('button[type="submit"]');

  const setLoading = (on) => {
    if (!button) return;
    button.disabled = on;
    button.classList.toggle('btn--loading', on);
    button.toggleAttribute('aria-busy', on);
  };

  const showFeedback = (type, title, message) => {
    if (!modal) return;
    modalRoot.classList.remove('modal--success', 'modal--error');
    modalRoot.classList.add(`modal--${type}`);
    if (modalTitle && title) modalTitle.textContent = title;
    if (modalText && message) modalText.textContent = message;
    modal.open(button);
  };

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    clearErrors(form);

    const errors = validate(form, config.messages);
    if (Object.keys(errors).length) {
      applyErrors(form, errors);
      return;
    }

    const body = new FormData(form);
    body.set('action', 'alx_contato');
    body.set('nonce', config.nonce);

    setLoading(true);
    const startedAt = Date.now();

    try {
      const response = await fetch(config.ajaxUrl, { method: 'POST', body, credentials: 'same-origin' });
      const payload = await response.json();

      const elapsed = Date.now() - startedAt;
      if (elapsed < MIN_BUSY_MS) await wait(MIN_BUSY_MS - elapsed);
      setLoading(false);

      if (payload.success) {
        form.reset();
        showFeedback('success', payload.data?.title, payload.data?.message);
      } else if (payload.data?.errors) {
        applyErrors(form, payload.data.errors);
      } else {
        showFeedback('error', payload.data?.title, payload.data?.message || config.messages.error_generic);
      }
    } catch {
      setLoading(false);
      showFeedback('error', config.messages.error_title, config.messages.error_network);
    }
  });
}
